import React from 'react'
import Result from 'components/Result'

const R4 = () => {
  return (
    <Result
      type="モード系タイプ"
      slides={[
        {
          src: 'img-r4-1.jpg',
          brand: 'Romona Keveza',
          shop: '大阪梅田本店',
          href: 'https://www.ws-i.jp/dress_category/brand/main_brand/60_romona_keveza/',
        },
        {
          src: 'img-r4-2.jpg',
          brand: 'Sareh Nouri',
          shop: '大阪梅田本店',
          href: 'https://www.ws-i.jp/dress_category/brand/main_brand/90_sareh_nouri/',
        },
      ]}
    />
  )
}

export default R4
